import React from 'react'
import { t, Trans } from '@lingui/macro'

import { typeDataRefundsRowActions } from './index';
import { DashboardContentPage } from '../DashboardContentTable';

import { FiltersDashboard } from '../DashboardContentTable/FiltersDashboard';
import { DRefundsFilters } from './filters';
import { InputSearch } from '../../../UI/InputSearch/InputSearch';
import { DataTableDashboard } from '../DashboardContentTable/DataTableDashboard';
import { TableBody, TableHeader } from './tableData';
import { PopupPanelDashboard } from '../DashboardContentTable/PopupPanelDashboard';

import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';
import { IdRefundsStateDataItem } from 'model/dashboardRefunds/dRefundsReducer';
import {
    PopupDetailsRefund
} from 'components/containers/dashboard/dataRefunds/popupContents/popupDetails';
import { PopupPrint } from 'components/containers/dashboard/dataRefunds/popupContents/popupPrint';


// Type
export type typeViewDataRefunds = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

    openFilterBar: boolean
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>

    openPopupDetails: boolean
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>

    openPopupPrint: boolean
    setOpenPopupPrint: React.Dispatch<React.SetStateAction<boolean>>
    onCancelPrint: () => void
    onPrintSubmitClick: () => void

    searchValue: string
    onChangeSearchValue: (e: ( React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> )) => void
    onEnterSearch: () => void
    onClearSearch: () => void

    rowsActions: typeDataRefundsRowActions

    currentItem: IdRefundsStateDataItem | undefined
    pagination: typePaginationDashboardObject
    isActiveFilters: boolean
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const ViewDataRefunds: React.FC<typeViewDataRefunds> = ({
                                                                   variant,
                                                                   setSidebarOpen,
                                                                   openFilterBar, setOpenFilterBar,
                                                                   openPopupDetails, setOpenPopupDetails,
                                                                   openPopupPrint, setOpenPopupPrint,
                                                                   searchValue, onChangeSearchValue,
                                                                   onClearSearch, onEnterSearch,

                                                                   rowsActions,

                                                                   pagination,
                                                                   isActiveFilters, setIsActiveFilters
                                                               }) => {

    return (
        <DashboardContentPage
            headerTitle={ <Trans>Refunds</Trans> }
            setSidebarOpen={ setSidebarOpen }

        >
            {/* Filter bar */ }
            <FiltersDashboard
                variant={ variant }
                filters={ {
                    filtersForm: <DRefundsFilters setOpenFilterBar={ setOpenFilterBar } setIsActiveFilters={ setIsActiveFilters }/>,
                    openFilterBar: openFilterBar,
                    setOpenFilterBar: setOpenFilterBar,
                } }
                searchBar= {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' ? <InputSearch
                    id="RefundsSearch"
                    name="RefundsSearch"
                    placeholder={ t`Search by fiscal module Id` }
                    value={ searchValue }
                    onChange={ onChangeSearchValue }
                    onClear={ onClearSearch }
                    onKeyEnterDown={ onEnterSearch }
                /> : undefined }
                isActiveFilters={ isActiveFilters }
            />

            {/* Table data */ }
            <DataTableDashboard
                tableHeader={ <TableHeader/> }
                tableBody={ <TableBody variant={ variant } setOpenPopupDetails={ setOpenPopupDetails }
                                       rowsActions={ rowsActions }/> }
                pagination={ pagination }
            />

            {/* Popup Details Refunds dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Details</Trans> }
                openPopup={ openPopupDetails }
                setOpenPopup={ setOpenPopupDetails }
            >
                <PopupDetailsRefund setOpenPopup={ setOpenPopupDetails } crossLinkToSale={ true }/>
            </PopupPanelDashboard>

            {/* Popup Print dialog */ }
            <PopupPanelDashboard
                title={ <Trans>Print</Trans> }
                openPopup={ openPopupPrint }
                setOpenPopup={ setOpenPopupPrint }
            >
                <PopupPrint setOpenPopup={ setOpenPopupPrint }/>
            </PopupPanelDashboard>

        </DashboardContentPage>
    )
}
